import React from 'react';
import Header from './Header';
import MobilePhone from './MobilePhone';
import MobilePhoneQRCode from './MobilePhoneQRCode';
import OutputQRCode from './OutputQRCode';
import './App.css';
const axios = require('axios');

function App() {
  const [shareUrl, setShareUrl] = React.useState(null);
  const [outputUrl, setOutputUrl] = React.useState(null);

  React.useEffect(() => {
    getAppAndOutputURL();
  }, []);

  function getAppAndOutputURL() {
    axios({
      method: 'get',
      url: "https://ifetut5dh8.execute-api.us-west-2.amazonaws.com/dev/mobiledemo"
    })
    .then(function (response) {
      if (response && response.data && response.data.shareUrl && response.data.outputUrl) {
        setShareUrl(response.data.shareUrl);
        setOutputUrl(response.data.outputUrl);
        console.log('****** RETURN DATA ***********: ', response.data);
      }
    });
  }

  return (
    <div className="app">
      {/*<button onClick={() => {*/}
        {/*console.log('shareUrl: ', shareUrl);*/}
        {/*console.log('outputUrl: ', outputUrl);*/}
      {/*}}>Log</button>*/}
      <Header/>
      <MobilePhone
        shareUrl={shareUrl}
        outputUrl={outputUrl}
      />
      <MobilePhoneQRCode
        url={shareUrl}
      />
      <OutputQRCode
        url={outputUrl}
      />
    </div>
  );
}

export default App;
